// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"725":"a3c87404","755":"983ab0f3"}[chunkId] + ".js";
};